import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e438688"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key-usage" }
const _hoisted_2 = { class: "key-usage-header" }
const _hoisted_3 = { class: "key-usage-label" }
const _hoisted_4 = { class: "key-usage-progress" }
const _hoisted_5 = { "data-testid": "transaction-fee-estimate" }
const _hoisted_6 = { "data-testid": "controller-key-balance-available" }
const _hoisted_7 = {
  key: 0,
  class: "key-usage-progress-info"
}

import { computed, watch } from 'vue'

import GasProvider from './GasProvider.vue'
import useNumbers from '@/popup/compositions/useNumbers'
import { Error } from '@/popup/components/shared/Form/Form'
import Progress from '@/popup/components/shared/Progress.vue'
import { FrontendProfile } from '@/shared/models/Profile'
import { RelayServiceDBSchema } from '@/shared/Database/UPSettings/models'
import { GasProvider as GasProviderType } from '@/shared/models/GasProvider'
import FormattedTokenAmount from '@/popup/components/shared/FormattedTokenAmount.vue'
import { usePreferencesStore } from '@/popup/store/PreferencesStore'

type Props = {
  balance: number
  transactionFee: number
  currentProfile: FrontendProfile
  allRelayers: RelayServiceDBSchema[]
  selectedGasProvider: GasProviderType
}

type Emits = {
  (event: 'on-gas-provider-change', value: GasProviderType): void
  (event: 'over-balance', value: boolean): void
  (event: 'on-low-balance-cancel-click'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'KeyUsage',
  props: {
    balance: {},
    transactionFee: {},
    currentProfile: {},
    allRelayers: {},
    selectedGasProvider: {}
  },
  emits: ["on-gas-provider-change", "over-balance", "on-low-balance-cancel-click"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit

const preferences = usePreferencesStore()
const { formatNumber } = useNumbers()

const keyUsagePercentage = computed(() =>
  props.balance === 0
    ? 0
    : Number(((props.transactionFee / props.balance) * 100).toFixed(2))
)

const isOverBalance = computed(() => props.transactionFee > props.balance)

watch(isOverBalance, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    emits('over-balance', !!newValue)
  }
})

const barOverHalf = computed(() => keyUsagePercentage.value > 50)

const goToFundMyController = () => {
  if (isOverBalance.value) {
    emits('on-low-balance-cancel-click')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('confirmation.key_usage.header')), 1 /* TEXT */),
      _createVNode(GasProvider, {
        "current-profile": _ctx.currentProfile,
        "all-relayers": _ctx.allRelayers,
        balance: _ctx.balance,
        "selected-gas-provider": _ctx.selectedGasProvider,
        onOnGasProviderChange: _cache[0] || (_cache[0] = 
          value => emits('on-gas-provider-change', value)
        )
      }, null, 8 /* PROPS */, ["current-profile", "all-relayers", "balance", "selected-gas-provider"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Progress, {
        data: [
          {
            value: keyUsagePercentage.value,
            color: 'var(--neutral-90)',
            title: _unref(formatNumber)(_ctx.transactionFee),
          },
        ],
        "label-position": barOverHalf.value ? 'left' : 'right',
        class: _normalizeClass({
          error: isOverBalance.value,
        })
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(FormattedTokenAmount, {
              amount: `${_ctx.transactionFee}`,
              symbol: _unref(preferences).token.symbol,
              decimals: 18,
              "tooltip-placement": 'auto'
            }, {
              default: _withCtx(({ amount }) => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(amount), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["amount", "symbol"]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('confirmation.key_usage.transaction_fee_to_balance_separator')) + " ", 1 /* TEXT */),
            _createVNode(FormattedTokenAmount, {
              amount: `${_ctx.balance}`,
              decimals: 18,
              symbol: _unref(preferences).token.symbol,
              "tooltip-placement": 'auto'
            }, {
              default: _withCtx(({ amount, symbol }) => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(`${amount} ${symbol}`), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["amount", "symbol"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data", "label-position", "class"]),
      (!isOverBalance.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('confirmation.key_usage.progress_info')), 1 /* TEXT */))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "key-usage-progress-info",
            onClick: goToFundMyController
          }, [
            _createVNode(_unref(Error), {
              error: _ctx.$t('confirmation.key_usage.progress_error')
            }, null, 8 /* PROPS */, ["error"])
          ]))
    ])
  ]))
}
}

})